import locations from './locations';
import calendar from './calendar';
import { createEl } from '../../helpers/domHelpers';
import styles from '../../css/widgetModal.css';
import { widgetCtrl as ctrl } from '../../widgetController';

const calendarView = {
  init() {
    this.locationsElem = locations.init();
    this.calendarElem = calendar.init();

    this.calendarViewContainer = createEl('div', styles.calendarView);
    this.calendarViewContainer.append(this.calendarElem, this.locationsElem);

    return this.calendarViewContainer;
  },
  render() {
    ctrl.setCurrentDay(null);
    calendar.render();
    locations.render();
  },
};

export default calendarView;




// WEBPACK FOOTER //
// ./src/views/calendarView/index.js